import TeaserTile from './TeaserTile';
import React, {Fragment} from "react";
import translate from '../../services/translation';
import _ from "lodash";

export default class LatestTeaserTile extends TeaserTile {


	getTeaserImageContainer() {
		return null;
	}

	getTeaserTextContainer() {
		const teaserText = this.props.teaser.contentType === 'event' ? (
			<Fragment>
				<div>{this.props.teaser.additionalData.location}</div>
				<div>{this.props.teaser.additionalData.date}</div>
			</Fragment>
		) : _.truncate(this.props.teaser.teaser, {length: 120});

		return (
			<div className="teaserTextContainer">
				<div className="teaserTitle">{this.props.teaser.title}</div>
				<div className="teaserTeaser">{teaserText}</div>
				<div className="teaserLinkText">{translate('latest_teaser.teaser_link_' + this.props.teaser.contentType)}</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/TeaserTile/LatestTeaserTile.js